import { useQueryParam } from './useQueryParam';
import { deletePaginationParams, BEFORE_PARAM, AFTER_PARAM } from './usePaginationParams';

export const SEARCH_PARAM = 'search';

export type UseSearchParamsParameters = {
  searchParamName: string;
  beforeParamName: string;
  afterParamName: string;
};

export const useSearchParams = (
  { searchParamName, beforeParamName, afterParamName }: UseSearchParamsParameters = {
    searchParamName: SEARCH_PARAM,
    afterParamName: AFTER_PARAM,
    beforeParamName: BEFORE_PARAM,
  },
): [string | undefined, (search: string | undefined) => void] => {
  const [search, setSearch] = useQueryParam<string | undefined>(
    (searchParams) => {
      const search = searchParams.get(searchParamName);
      return search || undefined;
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(searchParamName, value);
      } else {
        searchParams.delete(searchParamName);
      }

      deletePaginationParams(searchParams, beforeParamName, afterParamName);
    },
  );

  return [search, setSearch];
};
